// Brand glyphs drawn inline so the dock shows the real marks.
export function XIcon({ size = 24 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-label="X">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.451-6.231zm-1.161 17.52h1.833L7.084 4.126H5.117l11.966 15.644z" />
    </svg>
  );
}

export function InstagramIcon({ size = 24 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-label="Instagram">
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
    </svg>
  );
}

export function LinkedInIcon({ size = 24 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-label="LinkedIn">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452z" />
    </svg>
  );
}

export function SubstackIcon({ size = 24 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-label="Substack">
      <path d="M22.539 8.242H1.46V5.406h21.08v2.836zM1.46 10.812V24L12 18.11 22.54 24V10.812H1.46zM22.54 0H1.46v2.836h21.08V0z" />
    </svg>
  );
}

export function VenmoIcon({ size = 24 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-label="Venmo">
      <path d="M5 3 L12 20 L19 3" />
    </svg>
  );
}

export function PayPalIcon({ size = 24 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-label="PayPal">
      <path d="M8.2 3h6.6c2.9 0 4.9 2 4.5 4.9-.4 3.1-2.6 4.9-5.6 4.9h-2.3l-.9 6.2a1.3 1.3 0 0 1-1.3 1.1H5.6a.9.9 0 0 1-.9-1.1L7.3 4.1A.9.9 0 0 1 8.2 3z" opacity="0.55" transform="translate(2.2,1)" />
      <path d="M7.2 2h6.6c2.9 0 4.9 2 4.5 4.9-.4 3.1-2.6 4.9-5.6 4.9h-2.3l-.9 6.2a1.3 1.3 0 0 1-1.3 1.1H4.6a.9.9 0 0 1-.9-1.1L6.3 3.1A.9.9 0 0 1 7.2 2z" />
    </svg>
  );
}

export function CashAppIcon({ size = 24 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-label="Cash App">
      <line x1="12" y1="2.5" x2="12" y2="21.5" />
      <path d="M16.8 5.5H9.5a3 3 0 1 0 0 6h5a3 3 0 1 1 0 6H6.5" />
    </svg>
  );
}
